import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../store";
import * as SelectSharedAccountCredentialsState from "../../store/SharedAccountCredentials";
import { TenantResponse } from "../../api/ApiClient";

import Modal from "../shared/Modal";

import "../shared/customModal.css";
import { RegisterAccount } from "./AdminAccounts";
import SelectSharedAccountCredentials from "../shared/SelectSharedAccountCredentials";
import { Button } from "components/ui/button";

type OwnProps = {};

interface Injected {}
type Props = Injected &
  typeof SelectSharedAccountCredentialsState.actionCreators &
  OwnProps;

type ModalType = "sharedCredentials" | null;

interface State {
  inProgress: boolean;
  showingModal: ModalType;
}

class AdminSharedAccountCredentials extends React.Component<Props, State> {
  state: State = {
    inProgress: false,
    showingModal: null,
  };

  showAddCredModal = () => {
    this.setState({ showingModal: "sharedCredentials" });
  };

  closeModal = () => {
    this.setState({ showingModal: null });
  };

  onRegisteredCred = async () => {
    this.closeModal();
    this.props.requestSharedCredentials();
  };

  renderRegisterCred = () => {
    return (
      //@ts-ignore
      <RegisterAccount
        hideUseSharedCredentials={true}
        registerOverride={this.props.registerSharedCredentials}
        registerButtonLabel="Register"
        onRegistered={this.onRegisteredCred}
      />
    );
  };

  public render() {
    const { showingModal } = this.state;

    return (
      <main className="space-y-6">
        <header className="pb-5 border-b border-slate-200 sm:flex sm:items-center sm:justify-between">
          <div>
            <h1 className="text-2xl font-semibold leading-7 text-slate-900">
              Shared Credentials
            </h1>
          </div>
          <Button
            className="mt-4 sm:mt-0"
            data-testid="shared-credentials-button-create"
            type="button"
            onClick={this.showAddCredModal}
          >
            Add Shared Credentials
          </Button>
        </header>
        {this.renderSharedCredentialsTable()}

        <Modal
          show={!!showingModal}
          onHide={this.closeModal}
          aria-labelledby="ModalHeader"
          dialogClassName="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="ModalHeader">
              {showingModal === "sharedCredentials"
                ? "Add Shared Credentials"
                : "?"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {showingModal === "sharedCredentials"
              ? this.renderRegisterCred()
              : null}
          </Modal.Body>
          <Modal.Footer>
            <Modal.Dismiss>Close</Modal.Dismiss>
          </Modal.Footer>
        </Modal>
      </main>
    );
  }

  private renderButton = (tenant: TenantResponse) => {
    return null;
  };

  private renderSharedCredentialsTable() {
    return (
      //@ts-ignore
      <SelectSharedAccountCredentials
        pageSize={5}
        renderButton={this.renderButton}
      />
    );
  }
}

export default connect<any, any, any, ApplicationState>(
  (state) => ({
    sites: state.sites,
  }),
  {
    ...SelectSharedAccountCredentialsState.actionCreators,
  },
)(AdminSharedAccountCredentials);
